import { Phone } from "lucide-react";
import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { PHONE, TEL } from "./data";
import { CITIES, SERVICE_PAGES } from "./seoData";

const Col = ({ title, links }) => (
  <div>
    <p className="mb-4 text-xs font-bold uppercase tracking-[0.28em] text-[#FFB000]">{title}</p>
    <ul className="grid gap-2">
      {links.map(([to, label]) => (
        <li key={to}><Link to={to} className="text-sm text-[#d6d2c8] transition-colors hover:text-[#FFB000]">{label}</Link></li>
      ))}
    </ul>
  </div>
);

export const Footer = () => (
  <footer data-testid="footer-section" className="border-t border-white/10 bg-[#0D0D0B] pb-28 pt-16 text-[#F2EEE6] md:pb-12">
    <div className="mx-auto max-w-7xl px-4 sm:px-6">
      <a data-testid="footer-phone-link" href={TEL} className="group block">
        <p className="text-xs font-bold uppercase tracking-[0.28em] text-[#FFB000]">Call Cazares</p>
        <p className="font-display mt-2 text-[17vw] leading-[0.85] tabular-nums transition-colors duration-500 group-hover:text-[#FFB000] lg:text-[11rem]">{PHONE}</p>
      </a>
      <nav aria-label="Footer" className="mt-14 grid gap-10 sm:grid-cols-2">
        <Col title="Junk removal services" links={SERVICE_PAGES.map((s) => [`/services/${s.slug}`, `${s.name} Greenville SC`])} />
        <Col title="Service area" links={CITIES.map((c) => [`/junk-removal/${c.slug}`, `Junk Removal ${c.name}, SC`])} />
      </nav>
      <div className="mt-12 flex flex-col gap-8 border-t border-white/10 pt-8 md:flex-row md:items-center md:justify-between">
        <Logo testid="footer-brand-logo" />
        <p className="text-sm text-[#bdb9af]">Junk removal in Greenville, South Carolina & nearby · Free onsite quotes · Same day pickup</p>
        <p className="text-sm text-[#bdb9af]">© {new Date().getFullYear()} Cazares Junk Removal</p>
      </div>
    </div>
  </footer>
);

export const MobileCallBar = () => (
  <a data-testid="mobile-call-bar" href={TEL} className="fixed inset-x-3 bottom-3 z-50 flex items-center justify-center gap-3 rounded-full bg-[#FFB000] py-4 text-lg font-black uppercase text-[#0D0D0B] shadow-[0_10px_40px_rgba(0,0,0,0.5)] md:hidden">
    <Phone className="h-5 w-5" strokeWidth={2.75} /> Call Now · <span className="tabular-nums">{PHONE}</span>
  </a>
);
